module.exports = __webpack_public_path__ + "static/media/city5.77f23573.jpg";